import { ContactDetailPage, ContactListPage } from "@Elements";
import { DashboardBaseRoute } from "./Dashboard.route";
import { createRoute, redirect } from "@tanstack/react-router";

export const ContactBaseRoute = createRoute({
  getParentRoute: () => DashboardBaseRoute,
  path: "/contact",
  staticData: {
    TITLE: "Demo",
    IS_BASE_ROUTE: true,
  },
  beforeLoad: (route) => {
    if (route.location.pathname === ContactBaseRoute.fullPath)
      throw redirect({
        to: ContactListRoute.fullPath,
      });
  },
});
export const ContactListRoute = createRoute({
  getParentRoute: () => ContactBaseRoute,
  path: "/list",
  component: ContactListPage,
  staticData: {
    TITLE: "Demo Talebi Listesi",
  },
});

export const ContactDetailRoute = createRoute({
  getParentRoute: () => ContactBaseRoute,
  path: "/detail/$id",
  component: ContactDetailPage,
  staticData: {
    TITLE: "Demo Talebi Detayı",
    PARENT_ROUTE: ContactListRoute,
  },
});

export const SupportRouteTree = ContactBaseRoute.addChildren([
  ContactListRoute,
  ContactDetailRoute,
]);
